import { ca } from '@cian/analytics';

import { adAnalyticsCategory } from '../../scripts/services/analytics.service';

export const trackShowIdentificationScreen = () => {
  ca('event', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'Show',
    label: 'Identification_screen',
  });
};
